import React from 'react';
import {Button, SvgIcon} from "@mui/material";
import Results from './Results';
import localStrings from "../../../localStrings";
import PageWithTitle from "../../../components/pages/pageWithTitle";
import {RouterLink} from "../../../components/router-link";
import {
  chartImplementationAddRoute,
  dashboardAddRoute,
  dashboardBaseRoute,
  establishmentAddRoute
} from "../../../routes/dashboard";
import PlusIcon from "@untitled-ui/icons-react/build/esm/Plus";

const DashBoardListView = () => {

  function getMainButtons() {
    return (
      <RouterLink to={'/' + dashboardBaseRoute + '/' + dashboardAddRoute}
                  style={{ textDecoration: 'none' }}
      >
        <Button
          color="primary"
          variant="contained"
          startIcon={(
            <SvgIcon>
              <PlusIcon />
            </SvgIcon>
          )}
        >
          {localStrings.addDashBoard}
        </Button>
      </RouterLink>
    )
  }

  return (
    <PageWithTitle title={localStrings.chartDashBoardList} mainButtons={getMainButtons()}>
       <Results/>
    </PageWithTitle>
  );
};

export default DashBoardListView;
